import React, { useState, useTransition } from 'react'
import step1d from '@/shared/assets/desktop/step1d.svg'
import step2d from '@/shared/assets/desktop/step2d.svg'
import step3d from '@/shared/assets/desktop/step3d.svg'
import { Button } from '@/shared/ui/Button/Button'
import { ContactForm } from '../ContactForm/ContactForm'
import { sendMetrik } from '@/shared/lib/utils/sendMetrik'
import { ReactComponent as YellowGlow } from '@/shared/assets/desktop/yellowGlow.svg'
import { ReactComponent as VioletGlow } from '@/shared/assets/desktop/VioletGlow.svg'
import { BGStars } from '@/shared/ui/BGStars/BGStars'
import { classNames } from '@/shared/lib/utils/classNames'
import cls from './Instruction.module.scss'
import { useTranslation } from 'react-i18next'

const Step = ({ title, imgSrc, description }) => {
    const { i18n } = useTranslation()
    return (
        <article className={classNames(cls.Step, [cls[`${i18n.language}`]])}>
            <h3>{title}</h3>
            <img
                src={imgSrc}
                alt={title}
            />
            <p>{description}</p>
        </article>
    )
}
export const Instruction = ({ variant = 'default' }) => {
    const [open, setOpen] = useState(false)
    const { t } = useTranslation()
    const steps = [
        {
            title: t('instructions.part1.title'),
            description: t('instructions.part1.description'),
            imgSrc: step1d,
        },
        {
            title: t('instructions.part2.title'),
            description: t('instructions.part2.description'),
            imgSrc: step2d,
        },
        {
            title: t('instructions.part3.title'),
            description: t('instructions.part3.description'),
            imgSrc: step3d,
        },
    ]
    return (
        <div
            id="instructions"
            className={classNames(cls.wrapper, [cls[variant]])}
        >
            <BGStars className={cls.InstructionStars} />
            {variant === 'distributor' && <YellowGlow className={cls.glow} />}
            <section className={cls.Instruction}>
                <h1>
                    {t('instructionTitle.part1')} <br /> <span>{t('instructionTitle.part2')}</span>
                </h1>

                <div className={cls.container}>
                    {steps.map((step) => {
                        return (
                            <Step
                                key={step.title}
                                {...step}
                            />
                        )
                    })}
                    {variant === 'default' && <VioletGlow className={cls.VioletGlow} />}
                </div>

                <div className={cls.buttonContainer}>
                    <Button
                        onClick={() => {
                            setOpen(true)
                            sendMetrik('click', 'bottom_main_page_contact_us_button')
                        }}
                        className={cls.contactButton}
                    />{' '}
                </div>

                <ContactForm
                    open={open}
                    setOpen={setOpen}
                />
            </section>
        </div>
    )
}
